import { TVas } from 'shared/types/vas';

export const ALL_VAS: TVas[] = [
  {
    title: 'Стандарт',
    views: 'до 100',
    backgroundColor: '#E6F0FF',
    mapPin: false,
    minIncrease: 50,
    maxIncrease: 100,
    vasId: 0,
  },
  {
    title: 'Премиум',
    views: 'до 200',
    backgroundColor: '#E6F0FF',
    mapPin: false,
    minIncrease: 100,
    maxIncrease: 200,
    vasId: 1,
  },
  {
    title: 'Топ',
    views: 'до 300',
    backgroundColor: '#F3EAFF',
    mapPin: true,
    minIncrease: 200,
    maxIncrease: 300,
    vasId: 2,
  },
  {
    title: 'Топ+Ставка',
    views: 'до 400',
    backgroundColor: '#F3EAFF',
    mapPin: true,
    minIncrease: 300,
    maxIncrease: 400,
    vasId: 3,
  },
];
